/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { Geofence } from '@polaris-customerweb/sharedcomponents.user-content';
import {
    CreateGeofence,
    DeleteGeofence,
    ForceGeofenceRefresh,
    GeofenceAction,
    SetActiveGeofence,
    SetEditableGeofence,
    SetGeofences,
    SetIsGeofenceEditing,
    ToggleActiveGeofence,
    UpdateGeofence,
} from '../geofence/geofence.actions';

export interface GeofenceState {
    activeGeofence: Geofence | undefined;
    editableGeofence: Geofence | undefined;
    forceRefresh: boolean;
    isGeofenceEditing: boolean;
    geofences: Geofence[];
}

const reducerMap: ActionReducerMap<GeofenceState> = {
    activeGeofence: activeGeofenceReducer,
    editableGeofence: editableGeofenceReducer,
    forceRefresh: forceRefreshReducer,
    geofences: geofencesReducer,
    isGeofenceEditing: isGeofenceEditingReducer,
};

export const selectGeofenceState =
    createFeatureSelector<GeofenceState>('geofence');
export const selectActiveGeofence = createSelector(
    selectGeofenceState,
    (state) => state.activeGeofence
);
export const selectEditableGeofence = createSelector(
    selectGeofenceState,
    (state) => state.editableGeofence
);
export const selectIsGeofenceEditing = createSelector(
    selectGeofenceState,
    (state) => state.isGeofenceEditing
);
export const selectGeofences = createSelector(
    selectGeofenceState,
    (state) => state.geofences
);
export const selectShouldForceGeofenceRefresh = createSelector(
    selectGeofenceState,
    (state) => state.forceRefresh
);

export const geofenceStoreModule = StoreModule.forFeature(
    'geofence',
    reducerMap
);

export function activeGeofenceReducer(
    state: Geofence | undefined,
    action: Action
) {
    switch (action.type) {
        case GeofenceAction.setActiveGeofence:
            return (action as SetActiveGeofence).geofence?.clone();
        case GeofenceAction.toggleActiveGeofence:
            if ((action as ToggleActiveGeofence).geofence?.id === state?.id) {
                return undefined;
            }

            return (action as ToggleActiveGeofence).geofence?.clone();
        default:
            return state;
    }
}

export function editableGeofenceReducer(
    state: Geofence | undefined,
    action: Action
) {
    switch (action.type) {
        case GeofenceAction.setEditableGeofence:
            return (action as SetEditableGeofence).geofence?.clone();
        default:
            return state;
    }
}

function forceRefreshReducer(state = true, action: Action) {
    switch (action.type) {
        case GeofenceAction.forceGeofenceRefresh:
            return (action as ForceGeofenceRefresh).forceRefresh;
        default:
            return state;
    }
}

export function isGeofenceEditingReducer(state = false, action: Action) {
    switch (action.type) {
        case GeofenceAction.setIsGeofenceEditing:
            return (action as SetIsGeofenceEditing).isEditing;
        default:
            return state;
    }
}

export function geofencesReducer(state: Geofence[] = [], action: Action) {
    switch (action.type) {
        case GeofenceAction.createGeofence:
            return [...state, (action as CreateGeofence).geofence.clone()];
        case GeofenceAction.deleteGeofence:
            return state.filter(
                (geofence) =>
                    geofence.id !== (action as DeleteGeofence).geofenceId
            );
        case GeofenceAction.setGeofences:
            return [...(action as SetGeofences).geofences];
        case GeofenceAction.updateGeofence:
            return [
                ...state.filter(
                    (geofence) =>
                        geofence.id !== (action as UpdateGeofence).geofence.id
                ),
                (action as UpdateGeofence).geofence.clone(),
            ];
        default:
            return state;
    }
}
